// Guide content for all pages in the application
// Each page should have a consistent guide at the top

export const GUIDE_CONTENT = {
  home: {
    icon: '🏠',
    title: 'Welcome to BookingFlows',
    description: 'Your complete booking and scheduling platform. Start by setting up your foundation: create roles, add members, and register assets.'
  },
  
  roles: {
    icon: '🛡️',
    title: 'Create Roles',
    description: 'Define team positions like Guide, Assistant, Instructor, or Manager. Roles help organize your team and set asset requirements.',
    dynamicDescription: (rolesCount) => 
      rolesCount > 0 
        ? `Great! You have ${rolesCount} role${rolesCount !== 1 ? 's' : ''} created. Now add teamMembers to assign these roles.`
        : 'Click "Create Role" to define your first team position (e.g., Guide, Assistant, Manager).'
  },
  
  team: {
    icon: '👥',
    title: 'Add TeamMembers',
    description: 'Build your team by adding members with contact info, roles, availability schedules, and portal login credentials.',
    dynamicDescription: (teamCount) =>
      teamCount > 0
        ? `Excellent! You have ${teamCount} teamMember${teamCount !== 1 ? 's' : ''}. Next, add your assets.`
        : 'Click "Add New Member" to add your first teamMember. Assign them a role and set their availability.'
  },
  
  assets: {
    icon: '🎯',
    title: 'Register Assets',
    description: 'Register your assets with capacity, member requirements, and availability.',
    dynamicDescription: (assetsCount) =>
      assetsCount > 0
        ? `🎉 Perfect! You have ${assetsCount} asset${assetsCount !== 1 ? 's' : ''} registered. Your core setup is complete!`
        : 'Click "Add New Asset" to register your first asset. Set member requirements and asset status.'
  },
  
  schedule: {
    icon: '📅',
    title: 'How Scheduling Works',
    description: 'Create and manage bookings using: AI auto-scheduler (intelligent assignment), FareHarbor imports, manual assignment (click a date), or widget bookings. All methods work together seamlessly.',
    actions: [
      {
        label: 'Generate Demo Data',
        icon: '✨',
        action: 'demo'
      }
    ]
  },
  
  bookings: {
    icon: '📋',
    title: 'Customer Bookings Management',
    description: 'View and manage all customer bookings from your widget, manual entries, or imports. Track booking status, confirm reservations, and handle cancellations or reschedules.'
  },
  
  financials: {
    icon: '💰',
    title: 'Financial Overview',
    description: 'Track your revenue, manage payouts, and view detailed booking breakdowns. Only Stripe fees (2.9% + $0.30) are deducted from your payouts - platform fees are paid by customers and through your subscription.'
  },
  
  network: {
    icon: '🤝',
    title: 'Member Network',
    description: 'Connect with local businesses to share resources. Search for available members by role, date, and time. Results show companies (not individual details for privacy). Send requests to connect.'
  },
  
  payroll: {
    icon: '💵',
    title: 'Payroll Calculator',
    description: 'Generate payroll reports based on bookings completed. Set custom pay rates, track hours, and calculate tip pool distribution for your team.'
  },
  
  services: {
    icon: '🎫',
    title: 'Services & Booking Widget',
    description: 'Create bookable services for your website. Configure pricing, capacity, duration, and generate embed codes for your booking widget.'
  },
  
  actions: {
    icon: '⚡',
    title: 'Quick Actions',
    description: 'Access powerful tools: AI auto-scheduler, FareHarbor imports, conflict detection, and system health monitoring.'
  },
  
  customers: {
    icon: '👤',
    title: 'Customer Management',
    description: 'View customer bookings, manage waivers, and handle customer portal access. Track customer history and booking preferences.'
  }
};

export default GUIDE_CONTENT;
